const reasons = [
  {
    icon: 'ri-home-heart-line',
    title: 'Family-Owned & Local',
    desc: 'Based in Campbell, CA — we know South Bay homes, neighborhoods, and weather patterns inside and out.',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Licensed & Insured',
    desc: 'Fully certified for roofing, solar, and general contracting. You\'re protected at every stage of the project.',
  },
  {
    icon: 'ri-file-list-3-line',
    title: 'Transparent Scopes',
    desc: 'Detailed project scopes with materials, methods, and timelines before work begins. No surprises, no hidden costs.',
  },
  {
    icon: 'ri-search-eye-line',
    title: 'Thorough Inspections',
    desc: 'We identify both immediate concerns and long-term factors — giving you the full picture, not just a quick quote.',
  },
  {
    icon: 'ri-time-line',
    title: 'Efficient Timelines',
    desc: 'We coordinate projects to minimize disruption and keep your schedule. Quality work, delivered on time.',
  },
  {
    icon: 'ri-sun-line',
    title: 'Roofing + Solar Expertise',
    desc: 'One team for your entire exterior — roof, gutters, solar, and battery systems. Seamless coordination, single point of contact.',
  },
];

export default function WhyChooseUs() {
  return (
    <section className="bg-white py-28">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row gap-16 items-start">

          {/* Left — images */}
          <div className="w-full lg:w-[44%] flex-shrink-0">
            <div className="relative" style={{ paddingBottom: '24px', paddingRight: '24px' }}>
              {/* Main image */}
              <div className="rounded-lg overflow-hidden w-full" style={{ height: '400px' }}>
                <img
                  src="https://lirp.cdn-website.com/785a78af/dms3rep/multi/opt/Shadow-roofing-and-solar-9-1536x1152-1920w.webp"
                  alt="Aerial view of a South Bay home with solar panels installed by Shadowfax Roofing & Solar"
                  className="w-full h-full object-cover object-top"
                />
              </div>

              {/* Floating secondary image */}
              <div
                className="absolute -bottom-0 -right-0 rounded-lg overflow-hidden border-4 border-white hidden lg:block"
                style={{ width: '175px', height: '140px', boxShadow: '0 4px 20px rgba(0,0,0,0.12)' }}
              >
                <img
                  src="https://lirp.cdn-website.com/785a78af/dms3rep/multi/opt/Shadow-roofing-and-solar-4-1920w.webp"
                  alt="Solar panel installation detail by Shadowfax Roofing"
                  className="w-full h-full object-cover object-top"
                />
              </div>

              {/* Gold badge */}
              <div
                className="absolute -top-5 -left-5 rounded-lg hidden lg:flex flex-col items-center justify-center"
                style={{ width: '96px', height: '96px', background: '#d4af37' }}
              >
                <p className="text-[#1a1a1a] text-2xl font-black leading-none" style={{ fontFamily: "'Montserrat', sans-serif" }}>100%</p>
                <p className="text-[#1a1a1a]/70 text-[9px] uppercase tracking-wider text-center mt-1 leading-tight font-bold" style={{ fontFamily: "'Montserrat', sans-serif" }}>Client<br />Focused</p>
              </div>
            </div>
          </div>

          {/* Right — content */}
          <div className="w-full lg:w-[56%] lg:pt-6">
            <span
              className="text-[#d4af37] text-[10px] uppercase tracking-[4px] font-bold block mb-5"
              style={{ fontFamily: "'Montserrat', sans-serif" }}
            >
              Why Shadowfax
            </span>
            <h2
              className="font-black text-[#0d1a27] leading-tight mb-5"
              style={{ fontFamily: "'Montserrat', sans-serif", fontSize: 'clamp(2rem, 3.5vw, 3rem)', letterSpacing: '-0.02em' }}
            >
              Dependable Service
              <br />
              <span className="text-[#d4af37]">Rooted in Local Familiarity</span>
            </h2>
            <p
              className="text-[#777] text-[15px] leading-[1.8] mb-10"
              style={{ fontFamily: "'Inter', sans-serif" }}
            >
              We&apos;re a family-owned business that understands Campbell&apos;s neighborhoods, the mix of older and newer South Bay homes, and the importance of getting exterior work done right the first time.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              {reasons.map((reason, idx) => (
                <div
                  key={idx}
                  className="flex items-start gap-4 bg-[#f9f9f7] rounded-lg p-5 border border-[#eeede8] hover:border-[#d4af37]/30 transition-all duration-300 hover:bg-white"
                >
                  <div
                    className="w-9 h-9 flex items-center justify-center rounded-full flex-shrink-0 mt-0.5"
                    style={{ background: 'rgba(212,175,55,0.1)' }}
                  >
                    <i className={`${reason.icon} text-[#d4af37] text-base`}></i>
                  </div>
                  <div>
                    <p
                      className="text-[#0d1a27] font-bold text-sm mb-1"
                      style={{ fontFamily: "'Montserrat', sans-serif" }}
                    >
                      {reason.title}
                    </p>
                    <p
                      className="text-[#888] text-xs leading-[1.7]"
                      style={{ fontFamily: "'Inter', sans-serif" }}
                    >
                      {reason.desc}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
